import { prop } from '@gov-nx/core/types';
import { usePersistedStore } from '../constants';

interface State {
	openedSteps: number[];
}

interface Store {
	wizards: { [name: string]: State };
	openStep: (name: string, index: number) => void;
	reset: (name: string) => void;
}

const initialState = {
	wizards: {},
};

export const useStore = <T>(selector: (state: Store) => T) =>
	usePersistedStore(
		(set) => ({
			...initialState,
			openStep: (name, index) =>
				set({ wizards: { [name]: { openedSteps: [index] } } }),
			reset: (name) => set({ wizards: { [name]: { openedSteps: [] } } }),
		}),
		'wizard',
		selector
	);

export const useWizardStore = <T extends keyof Store>(property: T): Store[T] =>
	useStore(prop(property));

export const useWizardStoreOpenedSteps = (name?: string) => {
	const wizards = useWizardStore('wizards');

	if (!name) return [];
	return wizards[name]?.openedSteps ?? [];
};
